import { configureStore } from "@reduxjs/toolkit";
import apiCoreMiddleware from "../APILayer/core/apiCoreMiddleware";

import { loginLoaderReducer, loginMidlleware } from "../APILayer/CommonAPIs/ApiLogin";
import {
  allLocationsReducer,
  fetchAllLocationsMidlleware,
} from "../APILayer/CommonAPIs/ApiGetLocations";
import {
  fetchAllCameraMiddleware,
} from "../APILayer/CommonAPIs/ApiGetCameras";
import {
  callGetEventsLoaderReducer,
  callGetEventsMidlleware,
} from "../APILayer/ManuDashboardAPIs/ApiGetEvents";
import {
  fetchCompanyDetailsMidlleware,
  companyDetailsReducer,
} from "../APILayer/CommonAPIs/ApiCodGetCompanyDetails";
import { setAppServerIpAddressReducer } from "./DevDemoVariables";
import {
  setIsLoggedInReducer,
  setDashboardConfigReducer,
  setApplicationConfigReducer,
  setEnabledRoutesReducer,
  setLocationSelectedReducer,
  setCameraSelectedReducer,
  setSearchStartDateReducer,
  setSearchEndDateReducer,
  setCameraDataReducer,
  setLocationsDataReducer,
  setWholeDataReducer,
  setAutoRefreshTimeReducer,
  setLocationSelectedMidlleware,
  setCameraSelectedMidlleware,
  setAllIncidentsReducer,
  setAnalyticSummaryPageDataReducer,
  setSelectedViewReducer
} from "./DashboardVariables";
import {
  callRuntimeEventsMidlleware,
  runtimeEventsLoaderReducer
} from "../APILayer/ManuDashboardAPIs/ApiGetRuntimeEvents";
import {
  setSelectedIncidentsReducer,
  setSelectedIncidentsMidlleware,
} from "./FilterVariables";
import { showSnackbarReducer } from "./ShowSnackbar";

export default configureStore({
  reducer: {
    companyDetails: companyDetailsReducer,
    allLocations: allLocationsReducer,

    // Global variables without middlewares
    snackbarData: showSnackbarReducer,
    appServerIpAddress: setAppServerIpAddressReducer,
    isLoggedIn: setIsLoggedInReducer,
    dashboardConfig: setDashboardConfigReducer,
    applicationConfig: setApplicationConfigReducer,
    enabledRoutes: setEnabledRoutesReducer,
    locationSelected: setLocationSelectedReducer,
    cameraSelected: setCameraSelectedReducer,
    searchStartDate: setSearchStartDateReducer,
    searchEndDate: setSearchEndDateReducer,
    cameraData: setCameraDataReducer,
    locationsData: setLocationsDataReducer,
    wholeData: setWholeDataReducer,
    autoRefreshTime: setAutoRefreshTimeReducer,
    selectedView: setSelectedViewReducer,

    selectedIncidents: setSelectedIncidentsReducer,
    allIncidents: setAllIncidentsReducer,

    // Derived data
    analyticSummaryPageData: setAnalyticSummaryPageDataReducer,

    // Loader variables
    loginLoader: loginLoaderReducer,
    runtimeEventsLoader: runtimeEventsLoaderReducer,
    callGetEventsLoader: callGetEventsLoaderReducer,
  },

  middleware: [
    loginMidlleware,

    callRuntimeEventsMidlleware,

    fetchCompanyDetailsMidlleware,
    fetchAllLocationsMidlleware,
    fetchAllCameraMiddleware,
    callGetEventsMidlleware,

    setLocationSelectedMidlleware,
    setCameraSelectedMidlleware,
    setSelectedIncidentsMidlleware,

    // This goes in the end
    apiCoreMiddleware,
  ],
});
